import React from 'react';

import {Box} from '@mui/system';
import IconLoading from '@components/UI/atoms/icons/IconLoading.svg';
import StatusMessage from '@/components/orderSimply/components/StatusMessage';
import ValidationErrorAfterMassive from '@/components/orderSimply/components/ValidationErrorMassiveJob';

interface FileValidationsProps {
    errors: any[];
    loading: boolean;
    showValidations: boolean;
    sx?: object;
}

const FileValidationsMassiveJob: React.FC<FileValidationsProps> = ({
    errors,
    showValidations,
    sx,
    loading,
}) => {
    return (
        <Box
            sx={{
                padding: errors.length > 1 ? 0 : '10px',
                paddingTop: errors.length > 0 ? '10px' : '20px',
                ...sx,
            }}
        >
            {loading ? (
                <StatusMessage message="Cargando..." iconSrc={IconLoading} color="#3276c3" />
            ) : (
                <>
                    {showValidations &&
                        errors?.length > 0 &&
                        errors?.map((error) => {
                            return (
                                <React.Fragment key={error.poReferenceId}>
                                    <ValidationErrorAfterMassive errorInfo={error} />
                                </React.Fragment>
                            );
                        })}
                </>
            )}
        </Box>
    );
};

export default FileValidationsMassiveJob;
